module.exports = __webpack_public_path__ + "img/listdownicon.3328d09a.svg";